// Task Management API Routes
export const PREDEFINED_TASKS_CREATE = "/v1/task-management/predefined-tasks/";
export const PREDEFINED_TASKS_LIST = "/v1/task-management/predefined-tasks/";
export const PREDEFINED_TASKS_UPDATE = "/v1/task-management/predefined-tasks/"; // + :id/
export const PREDEFINED_TASKS_DELETE = "/v1/task-management/predefined-tasks/"; // + :id/
export const PREDEFINED_TASKS_GET_BY_ID = "/v1/task-management/predefined-tasks/detail/"; // + :id/


// Task Assignment Routes
export const TASKASSIGNEMENT_LIST = "/v1/task-management/task-assignment/";
export const CREATE_TASKASSIGNMENT = "/v1/task-management/task-assignment/";
export const DELETE_TASKASSIGNMENT = "/v1/task-management/task-assignment/";
export const CREATE_PREDEFINEDTASKASSIGNEMENT = "/v1/task-management/task-assignment/bulk";
export const TASK_FILE_UPLOAD = "/v1/upload/";
export const TASK_GET_FILE = "/v1/upload/";

export const TASKASSIGNMENT_STATUS_COUNTS = "/v1/task-management/task-assignment/task-status-counts";
export const TASKASSIGNMENT_MY_TASKS = "/v1/task-management/task-assignment/my-tasks";
export const TASKASSIGNMENT_MY_TASKS_COUNTS = "/v1/task-management/task-assignment/my-tasks-counts";
export const TASKASSIGNMENT_DETAIL_BY_ID = "/v1/task-management/task-assignment/detail/";
export const UPDATE_TASKASSIGNMENT = "/v1/task-management/task-assignment/";
export const TASKASSIGNMENT_BY_ID = "/v1/task-management/task-assignment/"; 
export const UPDATE_MY_TASKS = "/v1/task-management/task-assignment/my-task/"; // + {taskId}
